/**
 * ShopDetailComponent on store details page
 **/

import $ from 'jquery';
import Singleton from 'components/utils/Singleton';
import StoreFinderComponent from './StoreFinderComponent';
import createLogger from 'components/logger/Logger';
import 'jquery.extendPrototype';
const Logger = createLogger('ShopDetailComponent');
  function ShopDetailComponent(settings) {
    StoreFinderComponent.call(this, settings, module);
    this.initialize();
  }

  $.extendPrototype(ShopDetailComponent, StoreFinderComponent.prototype, {
    settings: {
      storeDetailsSelectors:
        '.js-storeDetails-content-link--seeStore, .js-storeDetails-content-link--seeMap',
    },

    /**
     * Initialize
     */
    initialize() {
      Logger.info('Initialized');
      this.storeDetailsSelectors = document.querySelectorAll(this.settings.storeDetailsSelectors);

      this.bindEvents();
    },

    /**
     * Bind events
     */
    bindEvents() {
      this.storeDetailsSelectors.forEach((element) =>
        element.addEventListener('click', this.click.bind(this))
      );
    },

    /**
     * Click event
     */
    click() {
      this.storeDetailsSelectors.forEach((element) => element.classList.toggle('is-hidden'));
    },
  });

export default Singleton.create(ShopDetailComponent, 'ShopDetailComponent');
